import { Routes, Route, Navigate } from 'react-router-dom';
import { RefreshCw } from 'lucide-react';
import { Auth } from './components/Auth';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { ModalProvider } from './contexts/ModalContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { InfluencerProtectedRoute } from './components/InfluencerProtectedRoute';
import Onboarding from './pages/Onboarding';
import Welcome from './pages/Welcome';
import MainApp from './pages/MainApp';
import AppsLauncher from './pages/AppsLauncher';
import MoloniOAuthCallback from './pages/MoloniOAuthCallback';
import AuthCallback from './pages/AuthCallback';
import AuthLaunch from './pages/AuthLaunch';
import AuthDebug from './pages/AuthDebug';
import InfluencerLogin from './pages/InfluencerLogin';
import InfluencerPortal from './pages/InfluencerPortal';
import { ContentHubApp } from './contenthub/ContentHubApp';
import { MagicLinkReview } from './contenthub/pages/MagicLinkReview';

function AppRoutes() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 flex items-center justify-center">
        <div className="text-center">
          <RefreshCw className="w-12 h-12 mx-auto mb-4 text-accent-600 animate-spin" />
          <p className="text-gray-500 text-lg">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/auth/launch" element={<AuthLaunch />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/auth/debug" element={<AuthDebug />} />
      <Route path="/onboarding" element={<Onboarding />} />
      <Route path="/welcome" element={<Welcome />} />
      <Route path="/moloni/oauth/callback" element={<MoloniOAuthCallback />} />
      <Route path="/login" element={!user ? <Auth /> : <Navigate to="/apps" replace />} />
      <Route path="/creatorshub" element={<InfluencerLogin />} />
      <Route
        path="/creatorshub/portal"
        element={
          <InfluencerProtectedRoute>
            <InfluencerPortal />
          </InfluencerProtectedRoute>
        }
      />
      <Route path="/review/:token" element={<MagicLinkReview />} />
      <Route path="/contenthub/review/:token" element={<MagicLinkReview />} />
      <Route path="/contenthub/*" element={<ContentHubApp />} />
      <Route
        path="/apps"
        element={
          <ProtectedRoute>
            <AppsLauncher />
          </ProtectedRoute>
        }
      />
      <Route
        path="/main"
        element={
          <ProtectedRoute>
            <MainApp />
          </ProtectedRoute>
        }
      />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <MainApp />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Navigate to="/apps" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <LanguageProvider>
        <ModalProvider>
          <AppRoutes />
        </ModalProvider>
      </LanguageProvider>
    </AuthProvider>
  );
}
